import { Box, Card, Container, Skeleton } from '@mui/material';
import { useEffect } from 'react'
import { useState } from "react";
import api from '../../services/api';
import HeaderSession from '../../utils/headerSession';
import RegisterAccess from '../../utils/registerAccess';
import Paginacao from '../../utils/paginacao';
import { useSearchParams } from 'react-router-dom';
// import TabelaInfo from '../../utils/tabelaInfo';
import ButtonLeft from '../../utils/buttonLeft';
import ListaVazia from '../../utils/listaVazia';
// import TextFormatado from '../../utils/TextFormatado';

const styles = {
    root: {
        textAlign: 'justify',
        fontSize: 18,
        lineHeight: 1.5
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        paddingTop: 20,
        color: '#67348d',
        marginBottom: 15
    },
}

function SkeletonCard() {
    return (
        <Box>
            <Skeleton animation="wave" variant="rectangular" width={210} />
            <Box sx={{ pt: 0.5 }}>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" width="60%" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" width="100%" />
                <Skeleton animation="wave" width="100%" />
            </Box>
        </Box>
    );
}

const dadosTabela = [
    {
        ordem: 1,
        formaFarmaceutica: "Cápsulas, Comprimidos e Drágeas",
        laboratorioNacional: "100 unidades",
        laboratorioExterno: "250 - 500 unidades",
    },
    {
        ordem: 2,
        formaFarmaceutica:
            "Cremes e Pomadas (Auriculares, Oftálmicas, Rectais, Tópicas, Vaginais)",
        laboratorioNacional: "50 unidades",
        laboratorioExterno: "100 unidades",
    },
    {
        ordem: 3,
        formaFarmaceutica:
            "Ensaios de esterilidade e endotoxinas",
        laboratorioNacional: "40 unidades",
        laboratorioExterno: "80 unidades",
    },
    {
        ordem: 4,
        formaFarmaceutica:
            "Gotas Auriculares, Nasais e Oftálmicas",
        laboratorioNacional: "50 unidades",
        laboratorioExterno: "100 unidades",
    },
    {
        ordem: 5,
        formaFarmaceutica:
            "Pó para soluçōes injetáveis (+ de 50 g)",
        laboratorioNacional: "50 unidades",
        laboratorioExterno: "100 unidades",
    },
    {
        ordem: 6,
        formaFarmaceutica:
            "Pó para soluçōes injetáveis 50 g",
        laboratorioNacional: "100 unidades",
        laboratorioExterno: "250 - 500 unidades",
    },
    {
        ordem: 7,
        formaFarmaceutica:
            "Soluçōes Injetáveis (1 - 10) ml",
        laboratorioNacional: "100 unidades",
        laboratorioExterno: "250 - 500 unidades",
    },
    {
        ordem: 8,
        formaFarmaceutica:
            "Soluçōes Injetáveis (100 - 1000) ml",
        laboratorioNacional: "50 unidades",
        laboratorioExterno: "100 unidades",
    },
    {
        ordem: 9,
        formaFarmaceutica:
            "Soluçōes Injetáveis 20 ml",
        laboratorioNacional: "100 unidades",
        laboratorioExterno: "250 - 500 unidades",
    },
    {
        ordem: 10,
        formaFarmaceutica:
            "Soluçōes Injetáveis 50 ml",
        laboratorioNacional: "100 unidades",
        laboratorioExterno: "250 - 500 unidades",
    },
    {
        ordem: 11,
        formaFarmaceutica:
            "Supositórios",
        laboratorioNacional: "50 unidades",
        laboratorioExterno: "100 unidades",
    },
    {
        ordem: 12,
        formaFarmaceutica:
            "Xaropes, Gotas Orais, Loçōes, Soluçōes e Suspensōes",
        laboratorioNacional: "50 unidades",
        laboratorioExterno: "100 unidades",
    },
];

export default function GetSiteInfor({ menu = '', opcao = '', tipoFile = '', menuTitle = '' }) {
    const classes = styles
    const [load, setLoad] = useState(false)
    const [sitInfos, setSiteInfos] = useState('')
    const [configLista, setConfigLista] = useState('')
    const [perPage, setPerPage] = useState(50)
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page") ?? 1);
    const opcaoParams = searchParams.get("opcao");
    const menuParams = searchParams.get("menu");
    const tipoFileParams = searchParams.get("tipoFile");

    // const url = useLocation();
    // useEffect(() => {
    //     document.title = `${opcaoParams ?? tipoFileParams}-ARMED`;
    // }, [url.pathname, opcaoParams, tipoFileParams])

    useEffect(() => {
        setLoad(true);
        api.get(`/site-infos?menu=${menuParams ?? menu}&opcao=${opcaoParams ?? opcao}&tipoFile=${tipoFileParams ?? tipoFile}&sortBy=createdAt:${(menu || menuParams) ? 'DESC' : 'ASC'}&perPage=${perPage}&page=${page}`)
            .then(res => {
                setSiteInfos(res.data.siteInfos);
                setConfigLista(res.data);
            })
            .catch(() => {
            }).finally(() => {
                setLoad(false);
            });
    }, [menu, opcao, tipoFile, page, perPage, menuParams, opcaoParams, tipoFileParams])


    return (
        <Container style={{ maxWidth: 1000, minHeight: '90vh', marginBottom: 20 }}>

            <RegisterAccess page={opcaoParams ?? menuTitle} />
            <HeaderSession maiusculo={true} title={opcaoParams ?? tipoFileParams ?? menuTitle} />

            {load ?
                [...Array(10)].map((_, index) => (<SkeletonCard key={index} />))
                :
                sitInfos.length > 0 && (

                    sitInfos.map((info, index) => {
                        {/* const isLast = index === sitInfos.length - 1; */ }
                        return (
                            <Box key={info._id} sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 2, position: 'relative' }}>
                                <h1
                                    style={{ ...classes.title, textAlign: (menu || menuParams) === "SOBRE NÓS" ? "center" : undefined }}
                                >
                                    {info?.titulo?.toUpperCase()}
                                </h1>

                                <div
                                    style={{ ...classes.root, lineHeight: 1.5 }}
                                    dangerouslySetInnerHTML={{ __html: info?.conteudo }}
                                />

                                {/* <TextFormatado texto={info?.conteudo ?? ''}/> */}

                                {/* {info?.anexo && (
                                    <>
                                        {isLast && <TabelaInfo dados={dadosTabela} />}

                                        {info.anexo.includes("png") ? (
                                            !isLast && <img
                                                src={info.anexo}
                                                alt=""
                                                style={{ width: "100%", objectFit: "cover" }}
                                            />
                                        ) : (
                                            <a href={info.anexo} target="_blank" rel="noreferrer">
                                                Ver anexo
                                            </a>
                                        )}
                                    </>
                                )} */}

                                {info?.anexo && (
                                    <>
                                        {info.anexo.includes("png") ? (
                                            <img
                                                src={info.anexo}
                                                alt="Anexo"
                                                style={{ width: "100%", objectFit: "cover" }}
                                            />
                                        ) : (
                                            <ButtonLeft
                                                funcao={() => window.open(info.anexo, "_blank", "noopener,noreferrer")}
                                                title={'Ver anexo'}
                                            />
                                        )}
                                    </>
                                )}
                            </Box>
                        );
                    })
                )}

            {(!load && sitInfos.length < 1) && <ListaVazia text={'Sem informação disponivel'} />}


            <Card>
                <Paginacao
                    configLista={configLista}
                    lista={sitInfos}
                    page={page}
                    setPage={setPage}
                    setPerPage={setPerPage}
                />
            </Card>
        </Container>
    )
}

